module.exports = __webpack_public_path__ + "img/pregunta-4.8358ac5d.png";